import { createFileRoute } from "@tanstack/react-router";
import { PolicyPage, policyHead } from "../pages/PolicyPage";

export const Route = createFileRoute("/privacy-policy")({
  head: () => policyHead("privacy"),
  component: () => <PolicyPage page="privacy" />
});
